import axios from '../Backend';

export const onFacebookUserLogin = async (loginObj) => {
    try {
        axios.post('/channels/facebook/login', loginObj);
    } catch (e) {
        console.log('dispatch onFacebookUserLogin fail')
    }

}

export const onFacebookUserLogout = async (userID) => {
    try {
        axios.get('/channels/facebook/logout?userID=' + userID);
    } catch (e) {
        console.log('dispatch onFacebookUserLogin fail')
    }

}

export const fetch_FB_Postcomments = async (fb_post_id, channelId, msgType) => {
    try {
        await axios.get('/channels/facebookpage/fetchpostcomments?fb_post_id=' + fb_post_id + '&channelId=' + channelId + '&msgType=' + msgType);
        return true
    } catch (e) {
        console.log('fetch_FB_Postcomments fail')
        if (e.response && e.response.data) {
            console.log(e.response.data)
            return false
        }
        console.log(e)
    }

}

export const fetch_FB_FeedPosts = async (channelId, msgType) => {
    try {
        await axios.get('/channels/facebookpage/fetchfeedposts?channelId=' + channelId + '&msgType=' + msgType);
        return true
    } catch (e) {
        console.log('fetch_FB_FeedPosts fail')
        if (e.response && e.response.data) {
            console.log(e.response.data)
            return false
        }
        console.log(e)
    }

}